// Cobalt Bue
import hybridshellAirPodsProCobaltBlue1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-1.png";
import hybridshellAirPodsProCobaltBlue2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-2.png";
import hybridshellAirPodsProCobaltBlue3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-3.png";
import hybridshellAirPodsProCobaltBlue4 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-4.png";
import hybridshellBannerCobaltBlue1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-banner-1.jpg";
import hybridshellBannerCobaltBlue2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-banner-2.jpg";
import hybridshellBannerCobaltBlue3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-banner-3.jpg";
import hybridshellPosterCobaltBlue1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-poster-1.jpg";
import hybridshellPosterCobaltBlue2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-poster-2.jpg";
import hybridshellPosterCobaltBlue3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Cobalt Blue/hbs-k-cbb-poster-3.jpg";
import bottomBannerCobaltBlue from "../../assets/img/products/products/Banners Random/Banner - EarBuddyz - Black.jpg";
import prevCategory from "../../assets/img/products/products/Prev Next/prev-hybridshell.jpg";
import nextCategory from "../../assets/img/products/products/Prev Next/next-artisan.jpg";

// Black
import hybridshellAirPodsProBlack1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-1.png";
import hybridshellAirPodsProBlack2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-2.png";
import hybridshellAirPodsProBlack3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-3.png";
import hybridshellAirPodsProBlack4 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-4.png";
import hybridshellBannerBlack1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-banner-1.jpg";
import hybridshellBannerBlack2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-banner-2.jpg";
import hybridshellBannerBlack3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-banner-3.jpg";
import hybridshellPosterBlack1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-poster-1.jpg";
import hybridshellPosterBlack2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-poster-2.jpg";
import hybridshellPosterBlack3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Black/hbs-k-blk-poster-3.jpg";

// Pink
import hybridshellAirPodsProPink1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-bpk-1.png";
import hybridshellAirPodsProPink2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-bpk-2.png";
import hybridshellAirPodsProPink3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-bpk-3.png";
import hybridshellAirPodsProPink4 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-bpk-4.png";
import hybridshellBannerPink1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-banner-1.jpg";
import hybridshellBannerPink2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-banner-2.jpg";
import hybridshellBannerPink3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-banner-3.jpg";
import hybridshellPosterPink1 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-cbb-poster-1.jpg";
import hybridshellPosterPink2 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-cbb-poster-2.jpg";
import hybridshellPosterPink3 from "../../assets/img/products/products/Single Product/Hybridshell Keychain/Blush Pink/hbs-k-cbb-poster-3.jpg";

const hybridShellKeychain = [
  {
    id: "hybridshell-series-airpods-pro-case-keychain-cobalt-blue",
    name: "HybridShell Series \n AirPods Pro Case \n with keychain",
    device: "AirPods Pro",
    category: "AirPods Cases",
    series: "Hybridshell Series",
    colors: [
      {
        color: "#202020",
        url: "hybridshell-series-airpods-pro-case-keychain-black",
      },
      {
        color: "#4D5F7E",
        url: "hybridshell-series-airpods-pro-case-keychain-cobalt-blue",
      },
      {
        color: "#FFBFBF",
        url: "hybridshell-series-airpods-pro-case-keychain-pink",
      },
    ],
    selectedColor: "#4D5F7E",
    images: [
      hybridshellAirPodsProCobaltBlue1,
      hybridshellAirPodsProCobaltBlue2,
      hybridshellAirPodsProCobaltBlue3,
      hybridshellAirPodsProCobaltBlue4,
    ],
    description:
      "The HybridShell Series features the tough protection benefits of a polycarbonate hard shell and a proprietary dust resistant nano coating with a soft liquid silicone core. The two-piece design utilizes Restickable Secure Adhesive (RSA) in the lid to provide an ultra secure lid while the body is precisely engineered for a snug fit. \n\n The Stealth Button on the rear of the HybridShell Series case allows for intuitive access to the setup button on the rear of the AirPods charging case. The HybridShell Series Keychain case offers a convenient way to clip and carry your AirPods on the go.",
    note: "",
    banners: [hybridshellBannerCobaltBlue1, hybridshellBannerCobaltBlue2, hybridshellBannerCobaltBlue3],
    posters: [hybridshellPosterCobaltBlue1, hybridshellPosterCobaltBlue2, hybridshellPosterCobaltBlue3],
    relatedProducts: [
      "hybridshell-series-airpods-pro-case-keychain-black",
      "hybridshell-series-airpods-pro-case-keychain-pink",
      "hybridshell-series-airpods-pro-case-cobalt-blue",
    ],
    bottomBanner: { img: bottomBannerCobaltBlue, url: "/products/earbuddyz-for-airpods-pro-black" },
    relatedCategory: {
      prev: {
        img: prevCategory,
        url: "/products/hybridshell-series-airpods-pro-case-cobalt-blue",
      },
      next: {
        img: nextCategory,
        url: "/products/artisan-series-airpods-1-2-case-brown",
      },
    },
  },

  {
    id: "hybridshell-series-airpods-pro-case-keychain-black",
    name: "HybridShell Series \n AirPods Pro Case \n with keychain",
    device: "AirPods Pro",
    category: "AirPods Cases",
    series: "Hybridshell Series",
    colors: [
      {
        color: "#202020",
        url: "hybridshell-series-airpods-pro-case-keychain-black",
      },
      {
        color: "#4D5F7E",
        url: "hybridshell-series-airpods-pro-case-keychain-cobalt-blue",
      },
      {
        color: "#FFBFBF",
        url: "hybridshell-series-airpods-pro-case-keychain-pink",
      },
    ],
    selectedColor: "#202020",
    images: [
      hybridshellAirPodsProBlack1,
      hybridshellAirPodsProBlack2,
      hybridshellAirPodsProBlack3,
      hybridshellAirPodsProBlack4,
    ],
    description:
      "The HybridShell Series features the tough protection benefits of a polycarbonate hard shell and a proprietary dust resistant nano coating with a soft liquid silicone core. The two-piece design utilizes Restickable Secure Adhesive (RSA) in the lid to provide an ultra secure lid while the body is precisely engineered for a snug fit. \n\n The Stealth Button on the rear of the HybridShell Series case allows for intuitive access to the setup button on the rear of the AirPods charging case. The HybridShell Series Keychain case offers a convenient way to clip and carry your AirPods on the go.",
    note: "",
    banners: [hybridshellBannerBlack1, hybridshellBannerBlack2, hybridshellBannerBlack3],
    posters: [hybridshellPosterBlack1, hybridshellPosterBlack2, hybridshellPosterBlack3],
    relatedProducts: [
      "hybridshell-series-airpods-pro-case-keychain-cobalt-blue",
      "hybridshell-series-airpods-pro-case-keychain-pink",
      "hybridshell-series-airpods-pro-case-cobalt-blue",
    ],
    bottomBanner: { img: bottomBannerCobaltBlue, url: "/products/earbuddyz-for-airpods-pro-black" },
    relatedCategory: {
      prev: {
        img: prevCategory,
        url: "/products/hybridshell-series-airpods-pro-case-cobalt-blue",
      },
      next: {
        img: nextCategory,
        url: "/products/artisan-series-airpods-1-2-case-brown",
      },
    },
  },

  {
    id: "hybridshell-series-airpods-pro-case-keychain-pink",
    name: "HybridShell Series \n AirPods Pro Case \n with keychain",
    device: "AirPods Pro",
    category: "AirPods Cases",
    series: "Hybridshell Series",
    colors: [
      {
        color: "#202020",
        url: "hybridshell-series-airpods-pro-case-keychain-black",
      },
      {
        color: "#4D5F7E",
        url: "hybridshell-series-airpods-pro-case-keychain-cobalt-blue",
      },
      {
        color: "#FFBFBF",
        url: "hybridshell-series-airpods-pro-case-keychain-pink",
      },
    ],
    selectedColor: "#FFBFBF",
    images: [
      hybridshellAirPodsProPink1,
      hybridshellAirPodsProPink2,
      hybridshellAirPodsProPink3,
      hybridshellAirPodsProPink4,
    ],
    description:
      "The HybridShell Series features the tough protection benefits of a polycarbonate hard shell and a proprietary dust resistant nano coating with a soft liquid silicone core. The two-piece design utilizes Restickable Secure Adhesive (RSA) in the lid to provide an ultra secure lid while the body is precisely engineered for a snug fit. \n\n The Stealth Button on the rear of the HybridShell Series case allows for intuitive access to the setup button on the rear of the AirPods charging case. The HybridShell Series Keychain case offers a convenient way to clip and carry your AirPods on the go.",
    note: "",
    banners: [hybridshellBannerPink1, hybridshellBannerPink2, hybridshellBannerPink3],
    posters: [hybridshellPosterPink1, hybridshellPosterPink2, hybridshellPosterPink3],
    relatedProducts: [
      "hybridshell-series-airpods-pro-case-keychain-black",
      "hybridshell-series-airpods-pro-case-keychain-cobalt-blue",
      "hybridshell-series-airpods-pro-case-cobalt-blue",
    ],
    bottomBanner: { img: bottomBannerCobaltBlue, url: "/products/earbuddyz-for-airpods-pro-black" },
    relatedCategory: {
      prev: {
        img: prevCategory,
        url: "/products/hybridshell-series-airpods-pro-case-cobalt-blue",
      },
      next: {
        img: nextCategory,
        url: "/products/artisan-series-airpods-1-2-case-brown",
      },
    },
  },
];

export default hybridShellKeychain;
